import { combineEpics } from 'redux-observable'
import { walletEpic } from './wallet'
import { authEpic } from './auth'

export const rootEpic = combineEpics(
  walletEpic,
  authEpic
)


// WEBPACK FOOTER //
// ./src/store/epics/index.js